import { useState } from 'react';

const pokeHeaderAnimations = [
  {
    href: 'https://pokemondb.net/pokedex/ludicolo',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/normal/ludicolo.gif',
    alt: 'Ludicolo',
  },
  {
    href: 'https://pokemondb.net/pokedex/bulbasaur',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/normal/bulbasaur.gif',
    alt: 'Bulbasaur',
  },
  {
    href: 'https://pokemondb.net/pokedex/ampharos',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/normal/ampharos.gif',
    alt: 'Ampharos',
  },
  {
    href: 'https://pokemondb.net/pokedex/dragonite',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/normal/dragonite.gif',
    alt: 'Dragonite',
  },
  {
    href: 'https://pokemondb.net/pokedex/psyduck',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/normal/psyduck.gif',
    alt: 'Psyduck',
  },
  {
    href: 'https://pokemondb.net/pokedex/slowking',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/shiny/slowking.gif',
    alt: 'Slowking',
  },
  {
    href: 'https://pokemondb.net/pokedex/gulpin',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/normal/gulpin.gif',
    alt: 'Gulpin',
  },
  {
    href: 'https://pokemondb.net/pokedex/gengar',
    src: 'https://img.pokemondb.net/sprites/black-white/anim/normal/gengar.gif',
    alt: 'Gengar',
  },
];

export default function SiteHeader({ currentPath, onNavigate }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((open) => !open);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handlePageNavigation = (event, path) => {
    event.preventDefault();
    onNavigate(path);
    closeMenu();
  };

  return (
    <header className={`site-header${currentPath === '/casino' ? ' site-header--casino' : ''}${currentPath === '/craybot' ? ' site-header--craybot' : ''}`}>
      <a
        className="site-header__title"
        href="/"
        onClick={(event) => handlePageNavigation(event, '/')}
      >
        Cray&apos;s Website
      </a>
      <div className="site-header__pokemon" aria-label="Featured Pokemon">
        {pokeHeaderAnimations.map((pokemon) => (
          <a
            className="site-header__pokemon-link"
            key={pokemon.alt}
            href={pokemon.href}
            target="_blank"
            rel="noreferrer"
          >
            <img className="site-header__pokemon-sprite" src={pokemon.src} alt={pokemon.alt} />
          </a>
        ))}
      </div>
      <div className="site-header__nav">
        <button
          type="button"
          className={`menu-toggle${menuOpen ? ' is-open' : ''}`}
          onClick={toggleMenu}
          aria-expanded={menuOpen}
          aria-controls="site-menu"
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav
          id="site-menu"
          className={`site-menu${menuOpen ? ' is-open' : ''}`}
          aria-label="Primary navigation"
        >
          <a
            className={`site-menu__link${currentPath === '/' ? ' is-active' : ''}`}
            href="/"
            onClick={(event) => handlePageNavigation(event, '/')}
          >
            Home Page
          </a>
          <a
            className={`site-menu__link${currentPath === '/poke' ? ' is-active' : ''}`}
            href="/poke"
            onClick={(event) => handlePageNavigation(event, '/poke')}
          >
            My Pokemon Cards
          </a>
          <a
            className={`site-menu__link${currentPath === '/casino' ? ' is-active' : ''}`}
            href="/casino"
            onClick={(event) => handlePageNavigation(event, '/casino')}
          >
            Casino Simulator
          </a>
          <a
            className={`site-menu__link${currentPath === '/craybot' ? ' is-active' : ''}`}
            href="/craybot"
            onClick={(event) => handlePageNavigation(event, '/craybot')}
          >
            CrayBot
          </a>
          <a
            className={`site-menu__link${currentPath === '/resume' ? ' is-active' : ''}`}
            href="/resume"
            onClick={(event) => handlePageNavigation(event, '/resume')}
          >
            Contact and Resume Info
          </a>
        </nav>
      </div>
    </header>
  );
}
